module.exports = __webpack_public_path__ + "static/34-56097386c69811c06f53da2e9dc1ef2e.jpg";